const actions = {
  getListagemRequisicao: async (
    context,
    {
      vendor_id,
      page,
      perPage,
      criadoEm,
      solicitanteMatricula,
      ccDescricao,
      voucherId,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    let res = await api.get(`/transferencia-estoque/vouchers/listagem`, {
      params: {
        vendor_id,
        page,
        perPage,
        criadoEm,
        solicitanteMatricula,
        ccDescricao,
        voucherId,
      },
    });

    return res;
  },

  listarGrupoProdutos: async (context, { unidade, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups`, {
      params: {
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },

  getTurnos: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendor-shifts`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },

  vencidosList: async (context, { user_id, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/machine/users/${user_id}/products`, {
      params: {
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  listarProdutosLiberados: async (
    context,
    { per_page, vendor_id, search, user_id, grupo_id, tipo, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `/auth/users/${user_id}/produtos-na-regra`,

      {
        params: {
          per_page,
          vendor_id,
          search,
          grupo_id,
          tipo,
          page,
        },
      }
    );
    return response;
  },

  getUserEspecifico: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/users/${id}`);

    return response;
  },
  desligarUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`auth/users/${id}`);

    return response;
  },
  afastarUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`auth/users/${id}/change-status`, {
      user_id: id,
      status: "Afastado",
    });

    return response;
  },
  reativarUsuario: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`auth/users/${id}/change-status`, {
      user_id: id,
      status: "Ativo",
    });

    return response;
  },

  editarFuncionario: async (
    context,
    {
      id,
      name,
      email,
      sap,
      cost_center_id,
      function_id,
      admission_date,
      resignation_date,
      cargo,
      vendor_shift_id,
      tnumber,
      role,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/auth/users/${id}`, {
      sap,
      name,
      email,
      cost_center_id,
      function_id,
      admission_date,
      resignation_date,
      cargo,
      vendor_shift_id,
      tnumber,
      user_id: id,
      role,
    });

    return response;
  },
  indexarRegras: async (context, { usuarios }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/regra/atualizar-usuarios`, {
      usuarios,
    });

    return response;
  },
  editarRoles: async (context, { user, roles }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user}/roles/${roles}`);
    return response;
  },

  atribuirPerfil: async (context, { user_id, role_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user_id}/roles/${role_id}`);
    return response;
  },

  removerPerfil: async (context, { user_id, role_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${user_id}/detach-roles`, {
      roles: [role_id],
    });
    return response;
  },

  getFuncoes: async (context, { vendor_id, search, page, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/functions`, {
      params: {
        vendor_id,
        per_page,
        page,
        search,
      },
    });

    return response;
  },
};

export const simplificadoStore = {
  namespaced: true,
  actions,
};
